import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GetHelpHeroComponent } from "./hero/get-help-hero/get-help-hero.component";
import { HeroDirective } from "./hero/hero.directive";
import { HeroService } from "./hero/hero.service";
import { HeroComponent } from "./hero/hero/hero.component";
import { HomePageComponent } from "./home-page/home-page.component";
import { HomeRoutingModule } from "./home-routing.module";
import { SvgPhysiciansComponent } from "./svg/svg-physicians/svg-physicians.component";
import { SvgHealthRecordComponent } from "./svg/svg-health-record/svg-health-record.component";
import { SvgPharmacyComponent } from "@app/home/svg/svg-pharmacy/svg-pharmacy.component";
import { SvgRxRenewalComponent } from "@app/home/svg/svg-rx-renewal/svg-rx-renewal.component";
import { SmallCardComponent } from "@app/home/cards/small-card/small-card.component";
import { SmallCardSvgDirective } from "@app/home/cards/small-card-svg.directive";
import { CardsService } from "@app/home/cards.service";
import { HealthRecordCardComponent } from "@app/home/cards/health-record-card.component";
import { CardDirective } from "@app/home/card/card.directive";
import { RxRenewalCardComponent } from "@app/home/cards/rx-renewal-card.component";
import { CardComponent } from "@app/home/card/card.component";
import { PharmacyCardComponent } from "@app/home/cards/pharmacy-card.component";
import { MyPcpCardComponent } from "@app/home/cards/my-pcp-card/my-pcp-card.component";
import { SharedModule } from "@app/shared/shared.module";
import { SvgChoosePcpComponent } from "@app/home/svg/svg-choose-pcp/svg-choose-pcp.component";
import { OfficeService } from "@app/shared/office.service";
import { ListCardComponent } from "@app/home/cards/list-card/list-card.component";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";
import { HealthHistoryCardComponent } from "@app/home/cards/health-history-card/health-history-card.component";
import { SurveyService } from "@app/survey/survey.service";
import { DownloadAppCardComponent } from "@app/home/cards/download-app-card/download-app-card.component";
import { SvgDownloadAppComponent } from "@app/home/svg/svg-download-app/svg-download-app.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SendAppLinkGraphql } from "@app/home/cards/download-app-card/send-app-link-graphql.service";

@NgModule({
  declarations: [
    CardComponent,
    CardDirective,
    DownloadAppCardComponent,
    GetHelpHeroComponent,
    HealthHistoryCardComponent,
    HealthRecordCardComponent,
    HeroComponent,
    HeroDirective,
    HomePageComponent,
    ListCardComponent,
    MyPcpCardComponent,
    PharmacyCardComponent,
    RxRenewalCardComponent,
    SmallCardComponent,
    SmallCardSvgDirective,
    SvgChoosePcpComponent,
    SvgDownloadAppComponent,
    SvgHealthRecordComponent,
    SvgPharmacyComponent,
    SvgPhysiciansComponent,
    SvgRxRenewalComponent,
  ],
  entryComponents: [
    DownloadAppCardComponent,
    GetHelpHeroComponent,
    HealthHistoryCardComponent,
    HealthRecordCardComponent,
    ListCardComponent,
    MyPcpCardComponent,
    PharmacyCardComponent,
    RxRenewalCardComponent,
    SvgHealthRecordComponent,
    SvgPharmacyComponent,
    SvgRxRenewalComponent,
  ],
  imports: [CommonModule, HomeRoutingModule, SharedModule, FormsModule, ReactiveFormsModule],
  providers: [
    CardsService,
    HeroService,
    HomePageAnalyticsService,
    OfficeService,
    SurveyService,
    SendAppLinkGraphql,
  ],
})
export class HomeModule {}
